//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepertoireDisplayItem } from './RepertoireDisplayItem';
import { StudentNameDisplayItem } from './StudentNameDisplayItem';
import { RepertoireAssignmentStatus } from './Enums';

export class RepertoireAssignmentDisplayItem extends ItemBase {
    RepertoireID: string | null = null;
    Repertoire: RepertoireDisplayItem | null = null;
    Composer: string | null = null;     // OBSOLETE - Use only for compatibility
    Difficulty: string | null = null;     // OBSOLETE - Use only for compatibility
    Instrument: string | null = null;     // OBSOLETE - Use only for compatibility
    DateCompleted: string | null = null;
    DateStarted: string | null = null;
    Duration: number | null = null;     // OBSOLETE - Use only for compatibility
    Notes: string | null = null;
    Status: RepertoireAssignmentStatus = RepertoireAssignmentStatus.InProgress;
    StudentID: string | null = null;
    Student: StudentNameDisplayItem | null = null;
    TeacherID: string | null = null;     // OBSOLETE - Use only for compatibility
    Title: string | null = null;     // OBSOLETE - Use only for compatibility
    Genre: string | null = null;     // OBSOLETE - Use only for compatibility
    Language: string | null = null;     // OBSOLETE - Use only for compatibility
    NextPerformance: string | null = null;
    PerformanceCount: number = 0;

    constructor(initializer?: Partial<RepertoireAssignmentDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoireAssignmentDisplayItem";
}
